import React, {useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import AOS from 'aos';
import 'aos/dist/aos.css';
import recentActors from '../../assets/icon/recent_actors.svg';
import mediation from '../../assets/icon/mediation.svg';
import addTask from '../../assets/icon/add_task.svg';
import modelTraining from '../../assets/icon/model_training.svg';
import move from '../../assets/icon/move_to_inbox.svg';
import connected from '../../assets/icon/cast_connected.svg';
import insights from '../../assets/icon/insights.svg';
import compare from '../../assets/icon/compare_arrows.svg';
import scaleImg from '../../assets/img/scale_img.png';
import trend_1 from '../../assets/img/trend_1.png';
import section6Img from "../../assets/img/section6Img.png";
import moSection6Img from "../../assets/img/section6_mo.png";
import Trader_w from "../../assets/img/ACE_Trader_w.svg"; 
import Trader_r from "../../assets/img/ACE_Trader_r.svg"; 
import eXchange_w from "../../assets/img/ACE_eXchange_w.svg";
import eXchange_r from "../../assets/img/ACE_eXchange_r.svg";
import ADLIB_w from "../../assets/img/ADLIB_w.svg";
import ADLIB_r from "../../assets/img/ADLIB_r.svg";
import i_Trader_r from "../../assets/icon/ACE_Trader(red).svg";
import i_Trader_w from "../../assets/icon/ACE_Trader.svg";
import logo_Trader from "../../assets/img/ACE_Trader_logo.svg";
import i_exchange_r from "../../assets/icon/ACE_eXchange(red).svg";
import i_exchange_w from "../../assets/icon/ACE_eXchange.svg";
import logo_Exc from "../../assets/img/ACE _Exc _logo.svg";
import i_ADLIB_r from "../../assets/icon/ADLIB(red).svg";
import i_ADLIB_w from "../../assets/icon/ADLIB.svg";
import logo_ADLIB from "../../assets/img/ADLIB_logo.svg";
import { useLanguage } from '../../hooks/useLanguage';
import { BANNER_LIST_URL, LOGO_LIST_URL, INQUIRY_URL, BOARD_LIST_URL, ATTACHMENT_URL } from '../../utils/urls';
import instance from '../../services/services';
import { validateEmail, formatPhoneNumber } from '../../utils/validation';
import ReCAPTCHA from "react-google-recaptcha";

function Main() {
  const { t } = useLanguage();
  // main
  const barRef = useRef(null); // 메인 배너 진행 바 애니메이션 제어를 위한 DOM 참조
  const swiperRef = useRef(null); // 메인 Swiper 인스턴스 참조 
  const [bannerList, setBannerList] = useState([]);
  const [logoListTop, setLogoListTop] = useState([]); // 로고 상단
  const [logoListBottom, setLogoListBottom] = useState([]); // 로고 하단
  const [recaptchaValue, setRecaptchaValue] = useState(null); // 리캡챠 값
  const [latestNewsList, setLatestNewsList] = useState([]);
  const [latestNewsList2, setLatestNewsList2] = useState([]);
  const [traderData, setTraderData] = useState([]);
  const [exchangeData, setExchangeData] = useState([]);
  const [adlibData, setAdlibData] = useState([]);


  // 메인 배너에서 자동 진행을 위한 애니메이션 리셋 로직
  const handleSlideChange = () => {
    if (barRef.current) {
      barRef.current.classList.remove('animation');
      void barRef.current.offsetWidth; // Trigger reflow
      barRef.current.classList.add('animation');
    }
  };

  useEffect(() => {
    if (barRef.current) {
      barRef.current.classList.add('animation');
    }
  }, []);

  // 메인 배너 애니메이션 종료 후 슬라이드 넘기기
  const handleAnimationEnd = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  //section_1
  const [activeTab, setActiveTab] = useState(0); // section_1 현재 클릭된 탭 인덱스

  const tabSwiperRef = useRef(null);  // section_1 내부 Swiper 탭 제어용 Swiper 인스턴스 참조

  // 섹션1: Swiper 탭 선택 시, activeTab 및 슬라이드 이동 처리
  const handleTabClick = (index) => {
    setActiveTab(index);
    if (tabSwiperRef.current) {
      tabSwiperRef.current.slideToLoop(index); 
    }
  };


  const tabContent = [
    {
      iconOff: i_Trader_w,
      iconOn: i_Trader_r,
      logo: logo_Trader,
      text: t('section_1.tab1'),
      url: "/solutions/aceTrader" 
    },
    {
      iconOff: i_exchange_w,
      iconOn: i_exchange_r,
      logo: logo_Exc,
      text: t('section_1.tab2'),
      url: "/solutions/aceExchange"
    },
    {
      iconOff: i_ADLIB_w,
      iconOn: i_ADLIB_r,
      logo: logo_ADLIB,
      text: t('section_1.tab3'),
      url: "/solutions/adlib"
    },
    // 아래는 위 슬라이드 반복
    {
      iconOff: i_Trader_w,
      iconOn: i_Trader_r,
      logo: logo_Trader,
      text: t('section_1.tab1'),
      url: "/solutions/aceTrader" 
    },
    {
      iconOff: i_exchange_w,
      iconOn: i_exchange_r,
      logo: logo_Exc,
      text: t('section_1.tab2'),
      url: "/solutions/aceExchange"
    },
    {
      iconOff: i_ADLIB_w,
      iconOn: i_ADLIB_r,
      logo: logo_ADLIB,
      text: t('section_1.tab3'),
      url: "/solutions/adlib"
    },
  ];
  
  const tabLogo = [
    { off: Trader_w, on: Trader_r },
    { off: eXchange_w, on: eXchange_r} ,
    { off: ADLIB_w, on: ADLIB_r },

  ]
  
  // section_6
  const [isOpen1, setIsOpen1] = useState(false);
  const [selected1, setSelected1] = useState(null);
  const [selectedDisplay1, setSelectedDisplay1] = useState(null); // 화면 표시용 상태 추가

  const options1 = [
    { labelKey: 'section_6.option.advertiser', value: 'advertiser' },
    { labelKey: 'section_6.option.media', value: 'media' },
    { labelKey: 'section_6.option.with', value: 'with' },
    { labelKey: 'section_6.option.tag', value: 'tag' }
  ];
  
  const toggleSelect1 = () => setIsOpen1(!isOpen1);
  const handleOptionClick1 = (option) => {
    setSelected1(option.value); // 서버 전송용 값
    setSelectedDisplay1(option.labelKey); // labelKey 저장 // 화면 표시용 값
    setIsOpen1(false);
  }
  
  const [isOpen2, setIsOpen2] = useState(false);
  const [selected2, setSelected2] = useState(null);
  const [selectedDisplay2, setSelectedDisplay2] = useState(null); // 화면 표시용 상태 추가

  const options2 = [
    { labelKey: 'section_6.option.normal', value: 'normal' },
    { labelKey: 'section_6.option.service', value: 'service' },
    { labelKey: 'section_6.option.payment', value: 'payment' },
    { labelKey: 'section_6.option.member', value: 'member' },
    { labelKey: 'section_6.option.etc', value: 'etc' }
  ];

  const toggleSelect2 = () => setIsOpen2(!isOpen2);
  const handleOptionClick2 = (option) => {
    setSelected2(option.value); // 서버 전송용 값
    setSelectedDisplay2(option.labelKey); // labelKey 저장 // 화면 표시용 값
    setIsOpen2(false);
  }

  // 외부 클릭 감지 시, 셀렉박스 클로즈 
  const selectBox1Ref = useRef(null); // section_6 셀렉트박스 1 - 외부 클릭 감지를 위한 DOM 참조
  const selectBox2Ref = useRef(null); // section_6 셀렉트박스 2 - 외부 클릭 감지를 위한 DOM 참조

  // 셀렉트박스 외부 클릭 감지 - 열려있는 드롭다운 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectBox1Ref.current && !selectBox1Ref.current.contains(event.target)) {
        setIsOpen1(false);
      }
      if (selectBox2Ref.current && !selectBox2Ref.current.contains(event.target)) {
        setIsOpen2(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // AOS 애니메이션 초기화 (스크롤 시 애니메이션 효과)
  useEffect(() => {
    let aosDelay = 260; // 기본값 (PC)
    let aosOffset = 500;
    if (window.innerWidth < 768) {
      aosDelay = 80; // 모바일일 때 더 짧게
      aosOffset = 250;
    }
    AOS.init({
      duration: 700,
      anchorPlacement: 'top-center',
      offset: aosOffset,
      delay: aosDelay,
    });
  }, []);

  const techImages = [
    recentActors,
    mediation,
    addTask,
    modelTraining,
    move,
    connected,
    insights,
    compare
  ];

  const rawTechItems = t('section_2.techItems', []);
  const techItems = Array.isArray(rawTechItems) ? rawTechItems : []; // 다국어 번역 데이터가 배열인지 안전하게 확인하고 처리


  // section_3 애니메이션용 state
  const scaleContainerRef = useRef(null);
  const [imgSize, setImgSize] = useState({ width: 82, height: 50, borderRadius: 48 });

  // section_3 애니메이션
  useEffect(() => {
    const handleScroll = () => {
      if (!scaleContainerRef.current) return;
      const rect = scaleContainerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
  
      const stickyStart = rect.top <= 0;
      const stickyEnd = rect.bottom <= windowHeight;
  
      if (stickyStart && !stickyEnd) {
        const section = scaleContainerRef.current.parentElement.parentElement;
        const sectionRect = section.getBoundingClientRect();
        const totalScrollable = sectionRect.height - rect.height;
        const scrolled = Math.min(Math.abs(sectionRect.top), totalScrollable);
  
        const progress = scrolled / totalScrollable;
  
        // 최대 100vw, 100vh
        const minWidth = 82;
        const maxWidth = 100;
        const minHeight = 50;
        const maxHeight = 100;
        const minRadius = 48;
        const maxRadius = 0;
  
        const width = minWidth + (maxWidth - minWidth) * progress;
        const height = minHeight + (maxHeight - minHeight) * progress;
        const borderRadius = minRadius + (maxRadius - minRadius) * progress;
  
        setImgSize({
          width,
          height,
          borderRadius,
        });
      } else if (!stickyStart) {
        setImgSize({ width: 82, height: 50, borderRadius: 48 });
      } else if (stickyEnd) {
        setImgSize({ width: 100, height: 100, borderRadius: 0 });
      }
    };
  
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 배너 리스트 조회
  useEffect(()=> {
    const fetchBannerList = async () => {
      try{
        const response = await instance.post(BANNER_LIST_URL, {
          b_type: 'main', 
        });
        setBannerList(response.data.data);
      } catch (error) {
        console.error('배너 리스트 조회 오류:', error);
      }
    };
    fetchBannerList();
    
  }, []);

  // 로고 리스트 조회
  useEffect(()=> {
    const fetchLogoList = async () => {
      try{
        const response = await instance.post(LOGO_LIST_URL,
          {}
        );
        setLogoListTop(response.data.data.top);
        setLogoListBottom(response.data.data.bottom);
      } catch (error) {
        console.error('로고 리스트 조회 오류:', error);
      }
    };
    fetchLogoList();
  }, []);
  

  // 최신 소식 리스트
  useEffect(()=> {
    const fetchLatestNewsList = async () => {
      try{
        const response = await instance.post(BOARD_LIST_URL, {
          boardid: 'blog',
          offset: 1,
        })
        setLatestNewsList(response.data.data.data);
      } catch (error) {
        console.error('최신 소식 리스트 조회 오류:', error);
      }
    };
    fetchLatestNewsList();
  }, []);

  // 공지사항 최신 3개 데이터 조회
  useEffect(()=> {
    const fetchLatestNewsList = async () => {
      try{
        const response = await instance.post(BOARD_LIST_URL, {
          boardid: 'notice',
          offset: 1,
        })
        setLatestNewsList2(response.data.data.data);
      } catch (error) {
        console.error('최신 소식 리스트 조회 오류:', error);
      }
    };
    fetchLatestNewsList();
  }, []);

  // NHN ACE DOWNLOAD 데이터
  useEffect(()=> {
    const fetchAttachment = async () => {
      try {
        const response = await instance.post(ATTACHMENT_URL)
        setAdlibData(response.data.data.adlib);
        setExchangeData(response.data.data.exchange);
        setTraderData(response.data.data.trader);
      }
      catch(error) {
        console.error('첨부파일 데이터 가져오기 실패:', error);
      }
    }
    fetchAttachment();
  }, []);

  // 문의하기 폼 데이터
  const formRef = useRef(null);

  // 상태 관리를 위한 state 추가
  const [formData, setFormData] = useState({
    boardid: 'inquiry',
    board_type: 'advertiser',
    user_name: '',
    user_phone: '',
    user_email: '',
    subject: '',
    contents: '',
    agree: false
  });

  // 입력 핸들러
  const handleInputChange = (e) => {
    const { name, type, value } = e.target;
    
    if (type === 'checkbox') {
        setFormData(prev => ({
            ...prev,
            [name]: e.target.checked
        }));
        return;
    }

    // 전화번호 입력 처리
    if (name === 'user_phone') {
        const formattedPhone = formatPhoneNumber(value);
        setFormData(prev => ({
            ...prev,
            [name]: formattedPhone
        }));
        return;
    }

    // 일반 입력 처리 (이메일 포함)
    setFormData(prev => ({
        ...prev,
        [name]: value
    }));
  };

  // 이메일 블러(포커스 잃을 때) 핸들러 추가
  const handleEmailBlur = (e) => {
    const { value } = e.target;
    if (value && !validateEmail(value)) {
        alert('올바른 이메일 형식이 아닙니다.');
    }
  };

  // 문의하기 제출 핸들러 수정
  const handleInquirySubmit = async (e) => {
    e.preventDefault();
    
    // reCAPTCHA 검증 추가
    if (!recaptchaValue) {
        alert('로봇이 아님을 인증해주세요.');
        return;
    }

    // 필수 입력값 검증
    if (!formData.user_name || !formData.user_email || !formData.subject || !formData.contents) {
        alert('필수 항목을 모두 입력해주세요.');
        return;
    }

    // 이메일 유효성 검사
    if (!validateEmail(formData.user_email)) {
        alert('올바른 이메일 형식이 아닙니다.');
        return;
    }

    // 전화번호 유효성 검사 (선택적)
    if (formData.user_phone && formData.user_phone.replace(/-/g, '').length < 10) {
        alert('올바른 전화번호 형식이 아닙니다.');
        return;
    }

    if (!selected1 || !selected2) {
        alert('서비스 구분과 문의 구분을 선택해주세요.');
        return;
    }

    if (!formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.');
        return;
    }
    
    try {
      const formDataToSend = new FormData();
      
      // FormData에 데이터 추가
      formDataToSend.append('boardid', 'inquiry');
      formDataToSend.append('board_type', selected1);
      formDataToSend.append('service_type', selected2);
      formDataToSend.append('user_name', formData.user_name);
      formDataToSend.append('user_phone', formData.user_phone);
      formDataToSend.append('user_email', formData.user_email);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('contents', formData.contents);

      // reCAPTCHA 토큰 추가
      formDataToSend.append('recaptcha_token', recaptchaValue);

      const response = await instance.post(INQUIRY_URL, formDataToSend);
      
      if (response.data && response.data.success) {
        alert('문의가 성공적으로 접수되었습니다.');
        // 폼 초기화
        setFormData({
          boardid: 'inquiry',
          board_type: 'advertiser',
          user_name: '',
          user_phone: '',
          user_email: '',
          subject: '',
          contents: '',
          agree: false
        });
        setSelected1(null);
        setSelected2(null);
        setSelectedDisplay1(null); // 디스플레이 값도 초기화
        setSelectedDisplay2(null); // 디스플레이 값도 초기화
        setRecaptchaValue(null); // reCAPTCHA 초기화
        window.location.reload(); // 페이지 새로고침
      } else {
        throw new Error(response.data?.message || '문의 접수에 실패했습니다.');
      }
    } catch (error) {
      console.error('문의 제출 실패:', error);
      alert(error.message || '문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  const handleRecaptchaChange = (value) => {
      setRecaptchaValue(value);
  };

  // 키워드를 태그 배열로 변환
  const getTagsFromKeyword = (keyword) => {
    if (!keyword) return [];
    return keyword.split(',').map(tag => `# ${tag.trim()}`);
  };



    return (
        <div className='wrap'>
          {/* main */}
          <main>
            <div className='main_wrap'>
              <div className='main_inner'>
                <div className="swiper-card swiper-default swiper01 main_banner">
                  <Swiper
                    modules={[Autoplay, Pagination, Navigation]} // 추가
                    slidesPerView={1}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    speed={4000}
                    loop={true}
                    spaceBetween={30}
                    pagination={{
                      type: 'fraction',
                      clickable: true,
                      renderFraction: (currentClass, totalClass) => {
                        return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`;
                      },
                      formatFractionCurrent: (number) => number < 10 ? `0${number}` : number,
                      formatFractionTotal: (number) => number < 10 ? `0${number}` : number,
                    }}
                    navigation={{
                      prevEl: '.arrow_box .btn_point_left',
                      nextEl: '.arrow_box .btn_point',
                    }}
                    onSlideChange={handleSlideChange}
                    onSwiper={(swiper) => { swiperRef.current = swiper; }}
                  >
                    {bannerList?.map((banner, index) => (
                      <SwiperSlide key={index}>
                        <Link to={banner?.link_url} target={banner?.target_type === 'self' ? '_self' : '_blank'}>
                          <div className="item banner_box">
                            <picture>
                              <source 
                                media="(max-width: 767px)" 
                                srcSet={`https://admin.nhnace.com${banner?.mobile_img || banner?.pc_img}`} 
                              />
                              <img 
                                src={`https://admin.nhnace.com${banner?.pc_img}`} 
                                alt={`slide-${index}`} 
                                loading={index === 0 ? undefined : "lazy"} 
                              />
                            </picture>

                          </div>
                        </Link>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  <div className="bar_wrap">
                    <div className="bar">
                    <div
                      className="back"
                      ref={barRef}
                      onAnimationEnd={handleAnimationEnd}
                    ></div>
                    </div>
                  </div>

                  {/* 커스텀 화살표 */}
                  <div className='arrow_box'>
                    <div className='btn_point_left'>
                      {/* 모양만들기 */}
                      <span></span>

                      {/* 화살표 */}
                      <span></span>
                    </div>
                    <div className='btn_point'>
                      {/* 모양만들기 */}
                      <span></span>

                      {/* 화살표 */}
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='main_board'>
              <div className='m_b_item bg_3'>
                <h4>DEVELOPMENT GUIDE</h4>
                <ul className='down_i'>
                  <li
                    onClick={() => window.open('https://nhnent.dooray.com/share/pages/sVri5vimS5SEGsP33TbZxw/3590794452017042439', '_blank')}
                  >
                    Publisher Integration Guide
                    <i className='icon go_i'></i>
                  </li>
                  <li
                    onClick={() => window.open('https://nhnent.dooray.com/share/pages/sVri5vimS5SEGsP33TbZxw/4072558148875950790', '_blank')}
                  >
                    ADLIB SDK Integration Guide
                    <i className='icon go_i'></i>
                  </li>
                  <li
                    onClick={() => window.open('https://nhnent.dooray.com/share/pages/yWSqAfQgQCCXAKDuXjWZ0Q', '_blank')}
                  >
                    ACETRADER Creative Specifications
                    <i className='icon go_i'></i>
                  </li>
                </ul>
              </div>
              <div className='m_b_item bg_2'>
                <h4>NHN ACE DOWNLOAD</h4>
                <ul className='down_i'>
                  <li
                    onClick={() => window.open(`https://admin.nhnace.com${traderData?.file_path}`, '_blank')}
                  >
                    ACE Trader 
                    <i className='icon ic_down'></i>
                  </li>
                  <li
                    onClick={() => window.open(`https://admin.nhnace.com${exchangeData?.file_path}`, '_blank')}
                  >
                    ACE eXchange 
                    <i className='icon ic_down' ></i>
                    </li>
                  <li
                    onClick={() => window.open(`https://admin.nhnace.com${adlibData?.file_path}`, '_blank')}
                  >
                    ACE ADLIB
                    <i className='icon ic_down'></i>
                  </li> 
                </ul>
              </div>
              <div className='m_b_item bg_1'>
                <div className='notice_inner'>
                  <h4>NOTICE</h4>
                  <ul>
                    {latestNewsList2?.slice(0, 3).map((notice, index) => (
                      <li key={notice.b_seq || index}>
                        <Link to={`/resources/notice/noticeDetail/${notice.b_seq}`}>
                          {notice.subject}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <div className='btn_point'>
                    <Link to="/resources/notice">
                      {/* 모양만들기 */}
                      <span></span>
                      {/* 화살표 */}
                      <span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </main>
          {/* //main */}

          {/* section_1 */}
          <section className='section_1'>
            <div className='section_inner no'>
              <div className='section_title'>
                <h2>NEW & BETTER WAY OF Targeting AD!</h2>
              </div>
              <div className='tab_slide_container'>
                <Swiper
                  slidesPerView={'auto'}
                  centeredSlides={true}
                  loop={true}
                  initialSlide={0}
                  spaceBetween={0}
                  onSlideChange={(swiper) => setActiveTab(swiper.realIndex)}
                  onSwiper={(swiper) => { tabSwiperRef.current = swiper; }}
                  className="tab_slide_wrap"

                >
                  {tabContent.map((content,index) => (

                  <SwiperSlide 
                    key={index} 
                    className={`tab_slide ${activeTab === index ? 'active' : ''}`}
                    >
                    <div className='icon_change'>
                      {activeTab === index ? (
                        <figure className='icon_on'>
                          <img src={content.iconOn} alt="iconOn"/>
                        </figure>
                        ) : (
                        <figure className='icon_off'>
                          <img src={content.iconOff} alt="iconOff"/>
                        </figure>
                      )}
                    </div>
                    
                    <div className='slide_text'>
                      <figure>
                        <img src={content.logo} alt="logo"/>
                      </figure>
                      <p>
                        {content.text}
                      </p>
                      <div className='view_more'>
                        <Link to={content.url}>
                          <button type='button'>{t('section_1.view_more')}</button>
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  ))}
                </Swiper>

                <div className='tab_box'>
                  {tabLogo.map((tab, index) => (
                    <div 
                      className={`tab_item ${index === activeTab % tabLogo.length ? 'active' : ''}`}  // 현재 activeTab과 일치하는 탭에만 'active' 클래스 부여
                      key={index}
                      onClick={() => handleTabClick(index)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') handleTabClick(index);
                      }}
                    >
                      <figure className='tab_logo_off'>
                        <img src={tab.off} alt="logo_off"/>
                      </figure>
                      <figure className='tab_logo_on'>
                        <img src={tab.on} alt="logo_on"/>
                      </figure>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </section>
          {/* //section_1 */}


          {/* section_2 */}
          <section className='section_2'>
            <div className='section_inner'>
                <div className='section_title'>
                  <h2>{t('section_2.title')}</h2>
                  <p>{t('section_2.description')}</p>
                </div>
                <div className='tech_list'>
                  <ul>
                    {techItems.map((item,index) => (
                      <li key={index}  data-aos="fade-up" >
                        <div className='tech_left'>
                          <p>
                            {item.title.map((line, i) => (
                              <React.Fragment key={i}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))}
                          </p>
                          <span>
                            {item.spanText.map((line, i) => (
                              <React.Fragment key={i}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))}
                          </span>
                        </div>
                        <div className='tech_right'>
                          <img src={techImages[index]} alt={`tech-img-${index}`} />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
            </div>
          </section>
          {/* //section_2 */}


          {/* section_3 */}
          <section className='section_3'>
            <h3 className='hidden'>section_3</h3>
            <div className='section_inner'>
              <div className='scale_container' ref={scaleContainerRef}>
                <div
                  className='scale_img_box'
                  style={{
                    width: `${imgSize.width}vw`,
                    height: `${imgSize.height}vh`,
                    borderRadius: `${imgSize.borderRadius}px`,
                    overflow: 'hidden',
                    transition: 'width 0.8s ease, height 0.8s ease, border-radius 0.1s linear',
                    position: 'relative',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  <img src={scaleImg} alt="scaleImg"/>
                </div>
                <div className='text'>
                <p dangerouslySetInnerHTML={{ __html: t('section_3.txt') }} />
                </div>
              </div>
            </div>
          </section>
          {/* //section_3 */}

          
          {/* section_4 */}
          <section className='section_4'>
            <div className='section_inner'>
              <div className='section_title'>
                <h2>AD MARKETING INSIGHT & TRENDS</h2>
                <p>{t('section_4.description')}</p>
              </div>
            </div>
            <div className='slide_container'>
              <Swiper
                speed={300}  // 슬라이드 전환 속도 추가
                observer={true}  // DOM 변경 감지
                observeParents={true}  // 부모 요소 변경 감지
                slidesPerView={'auto'}
                spaceBetween={10}
                pagination={{
                  clickable: true,
                }}
                centeredSlides={false}
                loop={false}
                // loopedSlides={2}
                className="slide_Swiper"
                // breakpoints={{
                //   600: { slidesPerView: 1 , spaceBetween: 10, centeredSlides:true, loop:false }, //360이상에서
                //   768: { slidesPerView: 1 , spaceBetween: 20, centeredSlides:true, loop:false }, //360이상에서
                //   860: { slidesPerView: 1 , spaceBetween: 20, centeredSlides:false, loop:false }, //360이상에서
                //   1080: { slidesPerView: 2, spaceBetween:20, centeredSlides:false, loop:false }, // 900이상에서
                //   1200: { slidesPerView: 2, spaceBetween:20, centeredSlides:false, loop:false }, // 900이상에서
                //   1600: { slidesPerView: 3, spaceBetween:30,  centeredSlides:false, loop:false }, // 1600이상에서 
                // }}
              >
                {latestNewsList.map((blog, index) => (
                  <SwiperSlide key={blog.b_seq || index}>
                    <div className='slide_item main_slide'>
                      <Link to={`/resources/blog/blogDetail/${blog.b_seq}`}>
                        <div className='slide_top'>
                          <h4 className="ellipsis_2">{blog.subject}</h4>
                          <div className="ellipsis_2">
                            <ul>
                              {getTagsFromKeyword(blog.keyword).map((tag, i) => (
                                <li key={i}>{tag}</li>
                              ))} 
                            </ul>
                          </div>
                        </div>
                        <div className='slide_btm'>
                          <img 
                            src={blog.main_image ? `https://admin.nhnace.com${blog.main_image}` : trend_1} 
                            alt={blog.subject} 
                          />
                        </div>
                      </Link>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </section>
          {/* //section_4 */}


          {/* section_5 */}
          <section className='section_5'>
            <div className='section_inner'>
              <div className='section_title'>
                <h2>Partnering for Performance — With NHN ACE</h2>
                <p>{t('section_5.description')}</p>
              </div>
              <div className='logo_container'>
                <div className='logo_row move_left'>
                  {[...logoListTop, ...logoListTop, ...logoListTop].map((logo, index) => (
                    <div className='logo_box' key={index}>
                      <img src={`https://admin.nhnace.com${logo.logo_img}`} alt={logo.alt} />
                    </div>
                  ))}

                </div>
                <div className='logo_row move_right'>
                  {/* 매핑 */}
                  {[...logoListBottom, ...logoListBottom, ...logoListBottom].map((logo, index) => (
                    <div className='logo_box' key={index}>
                      <img src={`https://admin.nhnace.com${logo.logo_img}`} alt={logo.alt} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
          {/* //section_5 */}

          
          {/* section_6 */}
          <section className='section_6'>
            <div className='section_left'>
              <picture>
                <source media='(min-width:1500px)' srcSet={section6Img}/>
                <img src={moSection6Img} alt="반응형이미지" />
              </picture>
              <div className='contact_box'>
                <h4>Contact us</h4>
                <div className='section_title'>
                  <h2 dangerouslySetInnerHTML={{ __html: t('section_6.title') }} />
                  <span dangerouslySetInnerHTML={{ __html: t('section_6.description') }} />
                </div>
              </div>
            </div>

            <div className='section_right'>
              <div className='right_inner'>
                <form ref={formRef} onSubmit={handleInquirySubmit}>
                  <div className='two_box'>
                    <div className='box_wrap'>
                      <span className='label'>{t('section_6.s_type')}</span>
                      <div className={`select_box ${isOpen1 ? 'open' : ''}`} onClick={toggleSelect1} ref={selectBox1Ref}>
                        <p className={selectedDisplay1 ? '' : 'placeholder'} >
                          {selectedDisplay1 ? t(selectedDisplay1) : t('section_6.select_placeholder')}
                        </p>
                        {isOpen1 && (
                          <ul>
                            {options1.map((option, idx) => (
                              <li
                                key={idx}
                                onClick={() => handleOptionClick1(option)}
                              >
                                {t(option.labelKey)}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                    <div className='box_wrap'>
                      <span className='label'>{t('section_6.i_type')}</span>
                      <div className={`select_box ${isOpen2 ? 'open' : ''}`} onClick={toggleSelect2} ref={selectBox2Ref}>
                        <p className={selectedDisplay2 ? '' : 'placeholder'}>
                          {selectedDisplay2 ? t(selectedDisplay2) : t('section_6.select_placeholder')}
                        </p>
                        {isOpen2 && (
                          <ul>
                            {options2.map((option, idx) => (
                              <li
                                key={idx}
                                onClick={() => handleOptionClick2(option)}
                              >
                                {t(option.labelKey)}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='two_box'>
                    <div className='box_wrap'>
                      <span className='label'>{t('section_6.name')}</span>
                      <div className='input_box'>
                        <input
                          type='text'
                          name="user_name"
                          value={formData.user_name}
                          onChange={handleInputChange}
                          placeholder={t('section_6.company')}
                        />
                      </div>
                    </div>
                    <div className='box_wrap'>
                      <span className='label'>{t('section_6.number')}</span>
                      <div className='input_box'>
                        <input
                          type='text'
                          name="user_phone"
                          value={formData.user_phone}
                          onChange={handleInputChange}
                          placeholder={t('section_6.tel_p')}
                          maxLength={13}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='box_wrap'>
                    <span className='label'>{t('section_6.email')}</span>
                    <div className='input_box'>
                      <input
                        type='text'
                        name="user_email"
                        value={formData.user_email}
                        onChange={handleInputChange}
                        onBlur={handleEmailBlur}
                        placeholder={t('section_6.email_p')}
                      />
                    </div>
                  </div>

                  <div className='box_wrap'>
                    <span className='label'>{t('section_6.i_title')}</span>
                    <div className='input_box'>
                      <input
                        type='text'
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        placeholder={t('section_6.sub_p')}
                      />
                    </div>
                  </div>

                  <div className='box_wrap'>
                    <span className='label'>{t('section_6.message')}</span>
                    <div className='input_box'>
                      <textarea
                        className='txt_area'
                        name="contents"
                        value={formData.contents}
                        onChange={handleInputChange}
                        placeholder={t('section_6.mes_p')}
                      />
                    </div>
                  </div>

                  <div className='box_wrap'>
                    <span className='label'>{t('section_6.consent')}</span>
                    <div className='term_box'>
                      <div className='term_txt'>
                        {t('section_6.term')}
                      </div>
                    </div>
                      
                    <div className='check_box'>
                      <input 
                        type='checkbox' 
                        id="agree" 
                        name="agree" 
                        checked={formData.agree} 
                        onChange={handleInputChange}
                      />
                      <label htmlFor="agree">
                        <span>{t('section_6.agree')}</span>
                      </label>
                    </div>
                  </div>
                  {/* 리캡차 영역 */}
                  <div className='robot_check'>
                    <ReCAPTCHA
                        sitekey="6LesW1wrAAAAAEWNzDIvWFcEc5DVelluu8V-Y0eP"
                        onChange={handleRecaptchaChange}
                        theme="light"
                        size="normal"
                    />
                  </div>

                  <div className='btn_box'>
                    <button type="submit" className='inquiry_btn'>{t('section_6.submit')}</button>
                  </div>
                </form>
              </div>
            </div>
          </section>

        </div>
    );
}

export default Main;